require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tos.json") })
        }
      }, "path---tos");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tos!./.cache/json/tos.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---tos!./.cache/json/tos.json
// module chunks = 231608221292675